import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import PropTypes from 'prop-types';
import './AddMoreInfoButton.css';

const AddMoreInfoButton = ({ href, buttonText }) => (
  <div className="add-more-info" role="presentation" test={buttonText}>
    <Link to={href}>
      <FontAwesome icon="plus-circle" fontSize="1.7em" />
      <div>{buttonText}</div>
    </Link>
  </div>
);

AddMoreInfoButton.propTypes = {
  href: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};
export default AddMoreInfoButton;
